import React from "react";
import PropTypes from "prop-types";
import { DialogTitle, DialogContent, DialogActions } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import Dialog from "../Dialog/Dialog";
import Heading from "../Heading/Heading";
import Button from "../Button";

const ConfirmAlert = ({
  title,
  text,
  open,
  onConfirm,
  onClose,
  confirmButtonText,
  cancelButtonText,
  confirmButtonColor
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <Heading>{text}</Heading>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="secondary" onClick={onClose}>
          {cancelButtonText || t("ui.confirm.back")}
        </Button>
        <Button
          variant="contained"
          color={confirmButtonColor}
          onClick={onConfirm}
        >
          {confirmButtonText || t("ui.confirm.confirm")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmAlert.propTypes = {
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmButtonColor: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  text: PropTypes.string,
  title: PropTypes.string
};

ConfirmAlert.defaultProps = {
  text: "",
  title: "",
  cancelButtonText: undefined,
  confirmButtonText: undefined,
  confirmButtonColor: "error"
};

export default ConfirmAlert;
